import { EQUIPMENT_TYPE_IDS } from "../bookingCatalog";

const DAY_PRICE_PERIODS = [
  { field: "fullDay", suffix: "/day" },
  { field: "weekly", suffix: "/week" },
];

const KIT_PRICE_PERIODS = [{ field: "trip", suffix: "/trip" }];

const NIGHT_PRICE_PERIODS = [
  { field: "fullDay", suffix: "/day" },
  { field: "weekly", suffix: "/week" },
];

export const PRICE_CARD_CONFIG = [
  {
    key: "home.price.cards.solo_glide",
    title: "Solo Glide",
    items: ["Single SUP", "1 rider", "Stable all-round board"],
    type: "light",
    img: "/assets/sup2.png",
    pricingKey: "sup",
    equipmentTypeId: EQUIPMENT_TYPE_IDS.soloSup,
    pricePeriods: DAY_PRICE_PERIODS,
  },
  // {
  //   key: "home.price.cards.party_board",
  //   title: "Party board",
  //   items: ["Big SUP", "Up to 6 people", "Best for groups and families"],
  //   type: "light",
  //   img: "/assets/sup1.png",
  //   pricingKey: "big_sup",
  //   equipmentTypeId: EQUIPMENT_TYPE_IDS.bigSup,
  //   pricePeriods: DAY_PRICE_PERIODS,
  // },
  {
    key: "home.price.cards.aqua_arrows",
    title: "Aqua arrows",
    items: ["Single kayak", "Easy to steer"],
    type: "dark",
    img: "/assets/kayak.png",
    pricingKey: "kayak",
    equipmentTypeId: EQUIPMENT_TYPE_IDS.soloKayak,
    pricePeriods: DAY_PRICE_PERIODS,
  },
  {
    key: "home.price.cards.big_aqua_arrows",
    title: "Big Aqua arrows",
    items: ["Double kayak", "Built for two"],
    type: "light",
    img: "/assets/kayak_big.png",
    pricingKey: "big_kayak",
    equipmentTypeId: EQUIPMENT_TYPE_IDS.bigKayak,
    pricePeriods: DAY_PRICE_PERIODS,
  },
  {
    key: "home.price.cards.glow_pack",
    title: "Glow & Go Pack",
    items: ["Glowing sup", "Lit for night rides"],
    type: "dark",
    img: "/assets/glow_sup.png",
    pricingKey: "neon_board",
    equipmentTypeId: EQUIPMENT_TYPE_IDS.glowingSup,
    pricePeriods: NIGHT_PRICE_PERIODS,
  },
  {
    key: "home.price.cards.extras_kit",
    title: "Extras kit",
    items: ["Towel", "Waterproof phone case", "Sun cream"],
    type: "light",
    img: "/assets/extras.png",
    pricingKey: "kit",
    equipmentTypeId: EQUIPMENT_TYPE_IDS.utilities,
    pricePeriods: KIT_PRICE_PERIODS,
  },
  {
    key: "home.price.cards.included",
    title: "Included",
    items: ["Waterproof bag", "Life vests", "Paddles"],
    type: "dark",
    img: "/assets/sup_utils.png",
  },
];

export const EQUIPMENT_PRICE_META = {
  sup: {
    pricingKey: "sup",
    equipmentTypeId: EQUIPMENT_TYPE_IDS.soloSup,
    pricePeriods: DAY_PRICE_PERIODS,
  },
  big_sup: {
    pricingKey: "big_sup",
    equipmentTypeId: EQUIPMENT_TYPE_IDS.bigSup,
    pricePeriods: DAY_PRICE_PERIODS,
  },
  kayak: {
    pricingKey: "kayak",
    equipmentTypeId: EQUIPMENT_TYPE_IDS.soloKayak,
    pricePeriods: DAY_PRICE_PERIODS,
  },
  big_kayak: {
    pricingKey: "big_kayak",
    equipmentTypeId: EQUIPMENT_TYPE_IDS.bigKayak,
    pricePeriods: DAY_PRICE_PERIODS,
  },
  kit: {
    pricingKey: "kit",
    equipmentTypeId: EQUIPMENT_TYPE_IDS.utilities,
    pricePeriods: KIT_PRICE_PERIODS,
  },
  neon_board: {
    pricingKey: "neon_board",
    equipmentTypeId: EQUIPMENT_TYPE_IDS.glowingSup,
    pricePeriods: NIGHT_PRICE_PERIODS,
  },
};
